/**
 * @generated SignedSource<<5d72ef98d0208f0acc7551fd89bf0174>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NodeInput = {
  id: string;
};
export type NotificationsTabDeleteMutation$variables = {
  input: NodeInput;
};
export type NotificationsTabDeleteMutation$data = {
  readonly deleteNotification: {
    readonly id: string;
  };
};
export type NotificationsTabDeleteMutation = {
  response: NotificationsTabDeleteMutation$data;
  variables: NotificationsTabDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "GraphQLNotification",
    "kind": "LinkedField",
    "name": "deleteNotification",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationsTabDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationsTabDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "4fe54634053f8777801dcc7ae5719420",
    "id": null,
    "metadata": {},
    "name": "NotificationsTabDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation NotificationsTabDeleteMutation(\n  $input: NodeInput!\n) {\n  deleteNotification(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "71231bea39dd53502f03a46cf3c307c6";

export default node;
